import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import { Button, Table } from "react-bootstrap";
import Layout from "wrappers/layout";
import "./table.css";

const GoldSilverGraph = () => {
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTimeFrame, setSelectedTimeFrame] = useState("1W");

  const buttonNames = ["1D", "1W", "1M", "3M", "6M"];

  const calculateFromDate = useCallback((duration) => {
    const today = new Date();
    if (duration === "1D") today.setDate(today.getDate() - 1);
    else if (duration === "1W") today.setDate(today.getDate() - 7);
    else if (duration === "1M") today.setMonth(today.getMonth() - 1);
    else if (duration === "3M") today.setMonth(today.getMonth() - 3);
    else if (duration === "6M") today.setMonth(today.getMonth() - 6);
    else throw new Error("Invalid duration");
    return today.toISOString().slice(0, 10);
  }, []);

  const downsample = (data, maxPoints = 1000) => {
    const factor = Math.ceil(data.length / maxPoints);
    return data.filter((_, index) => index % factor === 0);
  };

  const fetchData = useCallback(async () => {
    const fromDate = calculateFromDate(selectedTimeFrame);

    const payload = {
      metalCode: ["AG", "AU"],
      fromDate,
    };

    setLoading(true);
    try {
      const response = await axios.post(
        "https://api.ebullion.in/get/gold-by-silver/ratio",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const rawData = response?.data?.data || [];


        const processedData = (selectedTimeFrame === "3M" || selectedTimeFrame === "6M")
          ? downsample(rawData, 1000)
          : rawData;

        setRes(processedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  }, [calculateFromDate, selectedTimeFrame]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const series = [
    {
      name: "INR / g",
      data: res,
    },
  ];

  const chartOptions = {
    chart: {
      id: "area-datetime",
      type: "area",
      zoom: { autoScaleYaxis: true },
      animations: { enabled: false },
      toolbar: { show: false },
    },
    title: { text: "Gold / Silver Ratio", align: "left" },
    yaxis: { title: { text: "Price (INR)" } },
    colors: ["#99834d"],
    stroke: { curve: "straight", width: 1 },
    markers: { size: 0 },
    dataLabels: { enabled: false },
    tooltip: { x: { format: "dd MMMM yyyy hh:mm TT" } },
    xaxis: {
      type: "datetime",
      min: res.length > 0 ? new Date(res[0]?.x).getTime() : undefined,
      tickAmount: 6,
    },
  };

  const renderButtons = () =>
    buttonNames.map((buttonName) => (
      <Button
        key={buttonName}
        variant="light"
        className={`rounded-square ${selectedTimeFrame === buttonName ? "selected" : ""}`}
        onClick={() => setSelectedTimeFrame(buttonName)}
        style={{
          backgroundColor: selectedTimeFrame === buttonName ? "#301250" : "#fff",
          fontWeight: "bold",
          color: selectedTimeFrame === buttonName ? "#fff" : "#000",
          border: "1px solid #ccc",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          margin: "5px",
          fontSize: "14px",
        }}
      >
        {buttonName}
      </Button>
    ));

  return (
    <Layout>
      <div className="chart-table-responsive">
        <Table striped bordered className="custom-table-chart">
          <tbody>
            <tr>
              <td colSpan={3} className="small-width">
                {renderButtons()}
              </td>
            </tr>
            <tr className="white-background">
              <td colSpan={3} className="bigger-width">
                {loading ? (
                  <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "350px",
                    color: "#99834d",
                    fontSize: "16px"
                  }}>
                    Loading chart...
                  </div>
                ) : (
                  <ReactApexChart
                    options={chartOptions}
                    series={series}
                    type="area"
                    height={350}
                   
                  />
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Layout>
  );
};

export default GoldSilverGraph;
